import { ifAuthenticated, mustBeAdmin } from "../util/auth";

const Promotion = () => import("../components/content/promotion/promotion");
const AddPromotion = () =>
  import("../components/content/promotion/addPromotion");

export const promotionRoute = {
  path: "/promotion",
  component: Promotion,
  // beforeEnter: ifAuthenticated
   beforeEnter: mustBeAdmin
};

export const addPromotionRoute = {
  path: "/add-promotion",
  component: AddPromotion,
   // beforeEnter: ifAuthenticated
   beforeEnter: mustBeAdmin
};
